import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import VANOview from "./VANOview";

export default function VanoOverlay({ open, setOpen, VanoId }) {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className="fixed inset-0 z-50 overflow-y-auto"
    >
      {/* Backdrop */}
      <DialogBackdrop
        className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
        enter="transition-opacity ease-linear duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-linear duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      />

      {/* Overlay panel */}
      <div className="flex items-center justify-center min-h-screen px-4 text-center sm:block sm:p-0">
        <DialogPanel
          className="relative inline-block w-full max-w-6xl my-20 overflow-hidden text-left align-middle transition-all transform shadow sm:align-middle"
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {/*VANO Content */}
          <div className=" md:px-5 xl:w-full">
            {/* Farmer Details */}
            <VANOview setOpen={setOpen} id={VanoId} />
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
